import { EncryptionType } from '@/shared/lib/secure-json/core/crypto-core/types';
export * from './scenarios';

import { ProfileType } from '../types';

export * from './errors';

export const getProfileEncryptionTypeById = (type: number): EncryptionType => {
  if (type === 1) {
    return 'rsa';
  } else if (type === 2) {
    return 'ecies';
  }

  throw new Error('Invalid encryption type');
};

export const getProfileType = (type: string): ProfileType => {
  switch (type) {
    case 'MAIN_USER':
      return ProfileType.MainUser;
    case 'BENEFICIARY':
      return ProfileType.Beneficiary;
    case 'ASSISTANT':
      return ProfileType.Assistant;
    default:
      throw new Error('Invalid encryption type');
  }
};
